import defaultSetBodyClass from "./defaultSetBodyClass";
import { defaultSetCookie } from "./cookie";

var defaultApplySetting = function defaultApplySetting(property, value) {
  defaultSetBodyClass(property, value);
  defaultSetCookie(property, value);
};

export default defaultApplySetting;